import type {
    PortableTextBlock,
    PortableTextBlockComponent,
    PortableTextComponents,
    PortableTextTypeComponent} from '@portabletext/react';
import {
    PortableText,
    toPlainText,
} from '@portabletext/react';
import type { StudioPathLike } from '@sanity/client/csm';
import slugify from '../../utils/slugify';
import useDataAttribute, { ScopeDataAttribute } from '../infrastructure/DataAttributeContext';
import { Component } from './Component';
import { Phrase } from './Phrase';
import { marks } from './SimpleRichText';
import SkyraSurvey from './SkyraSurvey';
import { Textblock } from './Textblock';
import { FaqElementWrapper, FaqWrapper } from './faq';
import FileComponent from './fileComponent';
import { Float } from './float';
import Grid from './grid';
import { ImageWithMetadata } from './imageWithMetadata';
import { LinkCard } from './linkCard';
import * as style from './richText.module.css';
import { Table } from './table';
import { VimeoVideo } from './videoEmbed';

const types: Record<string, PortableTextTypeComponent> = {
    linkCard: LinkCard,
    imageWithMetadata: ImageWithMetadata,
    videoEmbed: VimeoVideo,
    table: Table,
    faq: FaqWrapper,
    faqItem: FaqElementWrapper,
    float: Float,
    grid: Grid,
    fileComponent: FileComponent,
    component: Component,
    phrase: Phrase,
    textblock: Textblock,
    skyraSurvey: SkyraSurvey,
};

const block: Record<string, PortableTextBlockComponent> = {
    h2: ({ children, value }) => {
        const attr = useDataAttribute();
        const slug = slugify(toPlainText(value));
        return (
            <h2 id={slug} data-sanity={value?._key && attr?.([{ _key: value._key }])}>
                <a href={`#${slug}`}>{children}</a>
            </h2>
        );
    },
    blockquote: ({ children }) => <blockquote className={style.quote}>{children}</blockquote>,
};

const richTextComponents: Partial<PortableTextComponents> = {
    types,
    marks,
    block,
};

export function RichText({ value = [], studioPath = 'richText' }: { value?: PortableTextBlock[]; studioPath?: StudioPathLike }) {
    return (
        <ScopeDataAttribute path={studioPath}>
            <PortableText value={value} components={richTextComponents} />
        </ScopeDataAttribute>
    );
}
